<template>
  <v-navigation-drawer
    class="primary accent-4 fill-height"
    dark
    v-model="drawer"
    mobile-breakpoint="960"
    :mini-variant.sync="mini"
    v-click-outside="onClickOutside"
    app
    id="navbar-id"
  >
    <v-list-item class="py-1 px-2">
      <v-list-item-avatar>
        <v-avatar color="rgb(218 27 49)" size="38">{{ initials }}</v-avatar>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ fullName }}</v-list-item-title>
      </v-list-item-content>

      <v-btn icon @click.stop="mini = !mini">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider></v-divider>
    <v-list class="side-bar-menu" nav dense>
      <template v-for="(item, i) of routes">
        <v-list-item
          v-if="
            (!item.children || item.children.length === 0) &&
            canScreen(item.permissionKey, item, item)
          "
          :key="i"
          :to="{ name: item.name, params: item.params }"
          exact
        >
          <v-list-item-icon>
            <v-img
              v-if="item.icon.includes('/images')"
              max-height="24"
              max-width="24"
              :src="item.icon"
            ></v-img>
            <v-icon v-else>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
        <v-list-group
          :class="{ 'dropdown-level-1': !mini }"
          :key="i"
          color="normal"
          v-if="
            item.children &&
            item.children.length &&
            canScreen(
              item.children.map((i) => i.permissionKey),
              item.children.map((i) => i.children),
              item
            )
          "
          :value="
            item.children
              .flat(1)
              .map((i) => i.name)
              .includes($route.name)
          "
        >
          <template v-slot:prependIcon>
            <v-img
              v-if="item.icon.includes('/images')"
              max-height="24"
              max-width="24"
              :src="item.icon"
            ></v-img>
            <v-icon v-else>{{ item.icon }}</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-for="(sub, j) of item.children">
            <v-list-item
              v-if="
                (!sub.children || sub.children.length === 0) &&
                canScreen(sub.permissionKey)
              "
              :key="j"
              :to="{ name: sub.name, params: sub.params }"
              exact
            >
              <v-list-item-icon>
                <v-img
                  v-if="sub.icon.includes('/images')"
                  max-height="24"
                  max-width="24"
                  :src="sub.icon"
                ></v-img>
                <v-icon v-else>{{ sub.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ sub.text }}</v-list-item-title>
            </v-list-item>
            <v-list-group
              :class="{ 'dropdown-level-2': !mini }"
              :key="j"
              color="normal"
              sub-group
              v-if="
                sub.children &&
                sub.children.length &&
                canScreen(sub.children.map((i) => i.permissionKey))
              "
            >
              <template v-slot:prependIcon>
                <v-img
                  v-if="sub.icon.includes('/images')"
                  max-height="24"
                  max-width="24"
                  :src="sub.icon"
                ></v-img>
                <v-icon v-else>{{ sub.icon }}</v-icon>
              </template>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ sub.text
                    }}<v-icon style="float: right; padding-right: 10px">
                      {{ "mdi-chevron-down" }}
                    </v-icon>
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="(sSub, k) of sub.children">
                <v-list-item
                  v-if="canScreen(sSub.permissionKey)"
                  :key="k"
                  :to="{ name: sSub.name, params: sSub.params }"
                  exact
                >
                  <v-list-item-icon>
                    <v-img
                      v-if="sSub.icon.includes('/images')"
                      max-height="24"
                      max-width="24"
                      :src="sSub.icon"
                    ></v-img>
                    <v-icon v-else>{{ sSub.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ sSub.text }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  async mounted() {
    this.$nextTick(async () => {
      await this.checkNavOverflow();
    });
  },
  computed: {
    fullName() {
      return this.$store.getters.user?.name;
    },
    initials() {
      if (!this.fullName) return;
      return this.fullName
        .split(" ")
        .map((n) => n[0])
        .join("");
    },
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isOpen() {
      this.drawer = this.isOpen;
      this.mini = false;
    },
    drawer() {
      this.$emit("update:isOpen", this.drawer);
    },
  },
  data() {
    return {
      scrollable: true,
      mini: true,
      drawer: !this.$vuetify.breakpoint.smAndDown,
      routes: [
        {
          name: "Dashboards",
          icon: "mdi-truck-delivery-outline",
          text: "Dashboards",
          children: [
            {
              name: "DashBoardsReports",
              icon: "mdi-view-dashboard-edit-outline",
              text: "Dashboard & Reports",
              permissionKey:
                "app_dashboard_report:dashboard_report_list_list_create",
            },
            {
              name: "PasDashBoards",
              icon: "mdi-view-dashboard-edit-outline",
              text: "Pas Dashboard",
              permissionKey: "app_pas:pas_report_dashboard",
            },
          ],
        },
        {
          name: "Slingshot",
          icon: "mdi-truck-delivery-outline",
          text: "Lastmile Delivery",
          children: [
            {
              name: "CarrierCoverage",
              icon: "mdi-radar",
              text: "Carrier Coverage",
              permissionKey:
                "app_carrier_partner:app_carrier_partner.apis.api_country_services_coverage.CarrierPartnerAPI",
            },
            {
              name: "Linehaul",
              icon: "/images/Linehaul.svg",
              text: "Allocation Rules",
              permissionKey: "app_linehaul:linehaul_list",
            },
            {
              name: "TrackingEvents",
              icon: "/images/Tracking Events.svg",
              text: "RSA Tracking Events",
              permissionKey: "tracking-event-list",
            },
            {
              name: "PackagesList",
              icon: "/images/Package White.svg",
              text: "Upload Package",
              permissionKey: "app_consignment_order:consignment_list",
            },
            {
              name: "PackagesListOld",
              icon: "/images/Package White.svg",
              text: "Update Offline Data",
              permissionKey:
                "app_consignment_order:lastmile-missing-oldpackage-upload",
            },
            {
              name: "PackageLabels",
              icon: "/images/Download Package Label.svg",
              text: "Download Label",
              permissionKey:
                "app_consignment_order:package_multiple_label_list",
            },
            {
              name: "InvoiceLabels",
              icon: "/images/Download Package Label.svg",
              text: "Download Invoice",
              permissionKey:
                "app_consignment_order:multiple_shipping_invoice_list",
            },
            {
              name: "PackageDetails",
              icon: "mdi-package-variant",
              text: "Package Details",
              permissionKey: "app_consignment_order:order_details",
            },
            {
              name: "Tracking",
              icon: "mdi-truck-fast-outline",
              text: "Track Shipment",
              permissionKey: "app_client:tracking_details",
            },
            {
              name: "CityDownload",
              icon: "mdi-city",
              text: "Download City Coverage",
              permissionKey: "app_linehaul:client-linehauls-list",
            },
            {
              text: "COD Reconciliation",
              icon: "mdi-cash-check",
              // name: "",
              children: [
                {
                  name: "CarrierCod",
                  icon: "mdi-cash-multiple",
                  text: "Payment Update",
                  permissionKey: "app_cod_reconcile:carrier-cod-payment_list",
                },
                {
                  name: "PendingCod",
                  icon: "mdi-cash-clock",
                  text: "Pending Payment",
                  permissionKey: "app_cod_reconcile:cod-payment-pending-list",
                },
                {
                  name: "DisputedCod",
                  icon: "mdi-close-box-multiple-outline",
                  text: "Disputed Payment",
                  permissionKey: "app_cod_reconcile:cod-disputed-order",
                },
                {
                  name: "ReconciliationCod",
                  icon: "mdi-cash",
                  text: "Reconciliation List",
                  permissionKey: "app_cod_reconcile:cod-pending-order-list",
                },
                {
                  name: "PaidCod",
                  icon: "mdi-cash-check",
                  text: "Paid Payment",
                  permissionKey:
                    "app_cod_reconcile:cod_payment_paid_summary_list",
                },
              ],
            },

            {
              text: "Billing",
              icon: "mdi-cash-check",
              children: [
                {
                  name: "BillingData",
                  icon: "mdi-cash-multiple",
                  text: "Upload Consignment Billing Data",
                  permissionKey:
                    "app_carrier_partner:carrier_consignment_billing_upload",
                },
                {
                  name: "PendingBilling",
                  icon: "mdi-cash-clock",
                  text: "Billing Pending Summary",
                  permissionKey:
                    "app_carrier_partner:lastmile_billing_pending_summary_list",
                },
                {
                  name: "BillingDataList",
                  icon: "mdi-close-box-multiple-outline",
                  text: "Billing Data",
                  permissionKey:
                    "app_carrier_partner:lastmile_billing_dataavailable_list",
                },
              ],
            },
            {
              name: "PrealertSection",
              icon: "mdi-bell",
              text: "Pre Alert",
              children: [
                {
                  name: "AddPreAlert",
                  icon: "mdi-file-alert-outline",
                  text: "Create Pre Alert Manifest",
                  permissionKey: "app_manifest:pre_alerts_upload",
                },
                {
                  name: "PreAlert",
                  icon: "mdi-file-document-alert-outline",
                  text: "List of Pre Alerts",
                  permissionKey: "app_manifest:pre_alerts_shipment_list",
                },
              ],
            },
            {
              name: "CarrierList",
              icon: "mdi-truck",
              text: "Delay in Carrier Tracking Update",
              permissionKey:
                "app_carrier_partner:carrier_event_update_tracking",
            },
            {
              name: "Rsaservices",
              icon: "mdi-truck",
              text: "RSA Services",
              permissionKey: "app_service_type:rsa_service_types_list",
            },
            {
              name: "Sla",
              icon: "mdi-truck",
              text: "SLA Configuration",
              children: [
                {
                  name: "SlaList",
                  icon: "mdi-file-document-alert-outline",
                  text: "List of SLA Configuration",
                  permissionKey: "app_sla_tracker:sla_carrier_config_list",
                },
                {
                  name: "SlaOrderTracking",
                  icon: "mdi-file-document-alert-outline",
                  text: "SLA Order Tracking",
                  permissionKey: "app_sla_tracker:sla_order_tracking_list",
                },
              ],
            },
            {
              name: "PudoList",
              icon: "mdi-link-variant-plus",
              text: "Pick & Collect Location List",
              permissionKey: "app_carrier_partner:carrier_pudo_list",
            },
            {
              name: "PudoSearch",
              icon: "mdi-magnify",
              text: "Find a Pick & Collect Location",
              permissionKey: "app_carrier_partner:carrier_pudo_list",
            },
          ],
        },
        {
          name: "Variant",
          icon: "mdi-account-multiple-outline",
          text: "Accounts",
          children: [
            {
              icon: "mdi-truck",
              text: "Carriers",
              children: [
                {
                  name: "Carriers",
                  icon: "mdi-truck",
                  text: "List of Carriers",
                  permissionKey: "app_carrier_partner:carrier_list",
                },
                {
                  name: "CarriersAddresses",
                  icon: "mdi-map-marker",
                  text: "Carriers Address(es)",
                  permissionKey: "app_carrier_partner:carrier_address_list",
                },
                {
                  name: "CarrierEventsUpload",
                  icon: "mdi-format-list-group",
                  text: "Carrier Tracking Events",
                  permissionKey: "app_carrier_partner:tracking-events-list",
                },
                {
                  name: "CountryUpload",
                  icon: "mdi-upload-multiple",
                  text: "Carriers Coverage Upload",
                  permissionKey: "app_carrier_partner:carrier-country-list",
                },
                {
                  name: "CarriersServices",
                  icon: "mdi-upload-multiple",
                  text: "Carriers Services",
                  permissionKey: "app_service_type:carrier_service_types_list",
                },
              ],
            },
            {
              icon: "mdi-domain",
              text: "Clients",
              children: [
                {
                  name: "Clients",
                  icon: "mdi-domain",
                  text: "List of Clients",
                  permissionKey: "app_client:client_list",
                },
                {
                  name: "ClientAddresses",
                  icon: "mdi-map-marker",
                  text: "Client Address(es)",
                  permissionKey: "app_client:client_address_list",
                },
                {
                  name: "ClientToken",
                  icon: "mdi-key",
                  text: "API token for Clients",
                  permissionKey: "app_client:client_generate_token_list",
                },
                {
                  name: "ProductHSCodeMap",
                  icon: "mdi-arrow-left-right",
                  text: "Mapping of Product Code",
                  permissionKey: "product-hs-codes",
                },
                {
                  name: "MapSellers",
                  icon: "mdi-plus",
                  text: "List of Sellers mapped",
                  permissionKey: "app_seller:mapped_seller_list",
                },
                {
                  name: "MappingOms",
                  icon: "mdi-link",
                  text: "Mapping OMS",
                  permissionKey: "app_ecom_vendors:oms_client_mapping_list",
                },
                {
                  name: "clientChannelMapping",
                  icon: "mdi-link-variant-plus",
                  text: "Mapping OMS Channel",
                  permissionKey:
                    "app_ecom_vendors:fulfillment_client_channel_mapping",
                },
              ],
            },
            {
              name: "vendor",
              icon: "/images/User Access White.svg",
              text: "Vendor",
              children: [
                {
                  name: "Addvendor",
                  icon: "mdi-upload-outline",
                  text: "Add Vendor",
                  permissionKey: "app_osl_overtime_cost:add_vendor",
                },
                {
                  name: "Listvendor",
                  icon: "mdi-upload-outline",
                  text: "List of Vendor",
                  permissionKey: "app_osl_overtime_cost:list_vendor",
                },
              ],
            },
            {
              name: "ManageSellers",
              icon: "mdi-human-dolly",
              text: "Manage Sellers",
              permissionKey: "app_seller:manage_seller",
            },
          ],
        },

        // {
        //   name: "Inbox",
        //   icon: "mdi-inbox",
        //   text: "Inbox",
        //   screen: "#49",
        // },

        // {
        //   icon: "mdi-arrow-down-left-bold",
        //   text: "Inbound",
        //   children: [
        //     {
        //       name: "NewConsolidations",
        //       icon: "mdi-new-box",
        //       text: "New Consolidations",
        //       screen: "#35",
        //     },
        //     {
        //       name: "LMNewConsolidations",
        //       icon: "mdi-new-box",
        //       text: "New Consolidations",
        //       screen: "#41",
        //     },
        //     {
        //       name: "Deconsolidated",
        //       icon: "mdi-file-tree-outline",
        //       text: "Deconsolidated",
        //       screen: "#36",
        //     },
        //     {
        //       name: "Merged",
        //       icon: "mdi-merge",
        //       text: "Merged",
        //       screen: "#37",
        //     },
        //     {
        //       name: "LMInClearance",
        //       icon: "mdi-middleware",
        //       text: "In Clearance",
        //       screen: "#45",
        //     },
        //   ],
        // },
        // {
        //   icon: "mdi-arrow-right-top-bold",
        //   text: "Outbound",
        //   children: [
        //     {
        //       name: "Staged",
        //       icon: "mdi-postage-stamp",
        //       text: "Staged",
        //       screen: "#38",
        //     },
        //     {
        //       name: "Dispatched",
        //       icon: "mdi-truck-delivery",
        //       text: "Dispatched",
        //       screen: "#39",
        //     },
        //     {
        //       name: "Departed",
        //       icon: "mdi-airplane-takeoff",
        //       text: "Departed",
        //       screen: "#48",
        //     },
        //   ],
        // },
        // {
        //   icon: "mdi-barcode-scan",
        //   text: "Scanning",
        //   children: [
        //     {
        //       name: "LMApplyScan",
        //       icon: "mdi-barcode-scan",
        //       text: "Apply Scan",
        //       screen: "#42",
        //     },
        //     {
        //       name: "LMScanUploadList",
        //       icon: "mdi-upload",
        //       text: "Bulk Scan Upload",
        //       screen: "#43",
        //     },
        //     {
        //       name: "LMMissingScan",
        //       icon: "mdi-barcode-off",
        //       text: "Missing Scan",
        //       screen: "#46",
        //     },
        //   ],
        // },

        {
          name: "Transport",
          icon: "mdi-van-utility",
          text: "Transport",
          permissionKey: "app_clickrf:dow_view_orders",
        },
        // {
        //   name: "SellersList",
        //   icon: "mdi-database-cog",
        //   text: "IOR Services",
        //   children: [
        //     {
        //       name: "SellersList",
        //       icon: "mdi-upload",
        //       text: "Upload Seller List",
        //       permissionKey: "app_seller:seller_upload_list_list_create",
        //     },
        //     {
        //       name: "SellerOnboardingStatus",
        //       icon: "mdi-upload",
        //       text: "Seller Onboarding Status",
        //       permissionKey: "app_seller:seller-pending-status-upload",
        //     },
        //     {
        //       name: "Invoices",
        //       icon: "mdi-receipt",
        //       text: "IOR Package",
        //       permissionKey: "app_seller:client_invoice_count",
        //     },
        //     {
        //       name: "Products",
        //       icon: "mdi-database",
        //       text: "Check Product Eligibility",
        //       permissionKey: "app_seller:product_temp_list",
        //     },
        //     {
        //       name: "ProductHSCode",
        //       icon: "mdi-arrow-left-right",
        //       text: "ProductCode-HSCode",
        //       permissionKey: "app_seller:products_verify_upload",
        //     },
        //     {
        //       name: "QuotesList",
        //       icon: "mdi-comment-quote",
        //       text: "Quotes",
        //       permissionKey: "app_seller:freight_list_list_create",
        //     },
        //     {
        //       name: "PendingPayments",
        //       icon: "mdi-cash-clock",
        //       text: "Pending Payments",
        //       permissionKey: "app_seller:invoice_pending_listing",
        //     },
        //     {
        //       name: "PaymentList",
        //       icon: "mdi-cash-clock",
        //       text: "List of Payments",
        //       permissionKey: "app_payment_gateway:payment_list_list_create",
        //     },
        //     {
        //       name: "BankTransfer",
        //       icon: "mdi-cash",
        //       text: "Bank Transfer",
        //       permissionKey: "app_payment_gateway:seller_invoice_list_create",
        //     },
        //     {
        //       name: "PaymentGatewayStatus",
        //       icon: "mdi-credit-card-outline",
        //       text: "Payment Gateway Status",
        //       permissionKey: "app_payment_gateway:order_id_list_create",
        //     },
        //   ],
        // },

        {
          icon: "mdi-truck",
          text: "B2B Fulfillment",
          children: [
            {
              name: "InboundList",
              icon: "mdi-truck",
              text: "Inbound Orders / Receipt",
              permissionKey: "app_infor:infor_v1_inbound_list",
            },
            {
              name: "InboundSummaryList",
              icon: "mdi-truck",
              text: "Inbound Orders/Receipt Summary",
              permissionKey: "app_infor:inbound_report_summary_list",
            },
            {
              name: "InboundSummaryGoods",
              icon: "mdi-truck",
              text: "Inbound Received Expiry Goods",
              permissionKey: "app_infor:b2b_inbound_received_good_expiry_list",
            },
            // {
            //   name: "InboundUpload",
            //   icon: "mdi-truck",
            //   text: "Inbound / Receipt  Upload",
            //   permissionKey: "app_infor:infor_v1_inbound_upload",
            // },
            {
              name: "OutboundList",
              icon: "mdi-truck",
              text: "Outbound Orders",
              permissionKey: "app_infor:infor_v1_outbound_list",
            },

            {
              name: "SKUB2BList",
              icon: "mdi-truck-delivery",
              text: "SKU",
              permissionKey: "app_sku_variant:b2b_sku_uploaded_list",

              children: [
                {
                  name: "SKUB2BUploadedList",
                  icon: "mdi-truck-delivery",
                  text: "Uploaded List",
                  permissionKey: "app_sku_variant:b2b_sku_uploaded_list",
                },
                {
                  name: "SKUB2BList",
                  icon: "mdi-truck-delivery",
                  text: "List",
                  permissionKey: "app_sku_variant:b2b_sku_list",
                },
              ],
            },
            {
              name: "SKUvariant",
              icon: "mdi-truck-delivery",
              text: "SKU Variant",
              permissionKey: "app_sku_variant:b2b_inbound_variant_summary",

              children: [
                {
                  name: "SkuVariantlist",
                  icon: "mdi-truck",
                  text: "SKU Variant List",
                  permissionKey: "app_sku_variant:b2b_sku_variant_list",
                },

                {
                  name: "SkuSearch",
                  icon: "mdi-truck",
                  text: "Search Sku Variant",
                  permissionKey: "app_sku_variant:b2b_sku_variant_list",
                },

                // {
                //   name: "AddSku",
                //   icon: "mdi-truck",
                //   text: "Add SKU Variant",
                //   permissionKey: "app_sku_variant:b2b_sku_variant_create",
                // },
                {
                  name: "LinkSku",
                  icon: "mdi-truck",
                  text: "SKU Variant Image",
                  permissionKey: "app_sku_variant:b2b_sku_image_link_unlink",
                },
              ],
            },
            {
              name: "Variant",
              icon: "mdi-truck-delivery",
              text: "Variant Orders / Receipt",
              permissionKey: "app_sku_variant:b2b_inbound_variant_summary",

              children: [
                {
                  name: "InboundSummary",
                  icon: "mdi-truck",
                  text: "Variant Orders / Receipt List",
                  permissionKey: "app_sku_variant:b2b_inbound_variant_summary",
                },
                {
                  name: "PriceRateList",
                  icon: "mdi-truck",
                  text: "Variant Labelling Status",
                  permissionKey: "app_sku_variant:b2b_inbound_variant_list",
                },
                {
                  name: "OutboundVariantList",
                  icon: "mdi-truck",
                  text: "Outbound Variant List",
                  permissionKey:
                    "app_sku_variant:b2b_outbound_variant_item_list",
                },
              ],
            },
            // {
            //   name: "HSCode",
            //   icon: "mdi-code-tags",
            //   text: "Lookup HS Code",
            //   permissionKey: "search-hs-code",
            // },
            {
              name: "B2binventory",
              icon: "mdi-truck",
              text: "B2B Inventory",
              permissionKey: "app_infor:b2b_infor_v1_inventory",
            },
            {
              name: "B2binventorySummary",
              icon: "mdi-truck",
              text: "B2B Inventory Summary",
              permissionKey: "app_infor:b2b_infor_v1_inventory",
            },
            {
              name: "B2binventorySummaryExpiry",
              icon: "mdi-truck",
              text: "B2B Inventory Item Summary",
              permissionKey: "app_infor:b2b_infor_v1_inventory",
            },

            {
              name: "Supplier",
              icon: "mdi-truck-delivery",
              text: "Supplier",

              children: [
                {
                  name: "SupplierList",
                  icon: "mdi-truck",
                  text: "Supplier List",
                  permissionKey: "app_infor:b2b_supplier_mapping_list",
                },

                {
                  name: "MappedSupplierList",
                  icon: "mdi-truck",
                  text: "Mapped Supplier List",
                  permissionKey: "app_infor:b2b_supplier_mapping_list",
                },
              ],
            },
            {
              name: "ASNList",
              icon: "mdi-truck",
              text: "ASN Reopen",
              permissionKey: "app_infor:b2b_inbound_asn_reopen_list",
            },
            {
              name: "ApiResponse",
              icon: "mdi-cable-data",
              text: "Client Transaction Summary",
              permissionKey: "app_infor:client_api_pending_summary",
            },

            {
              name: "ApiResponseClosed",
              icon: "mdi-cable-data",
              text: "Client Closed Transactions",
              permissionKey: "app_infor:client_api_pending_summary",
            },
          ],
        },
        {
          icon: "mdi-truck",
          text: "Finance",
          children: [
            {
              name: "Finance",
              icon: "mdi-truck",
              text: "Finance Summary",
              permissionKey: "app_finance:finance_data_list",
            },
          ],
        },
        {
          name: "FulfillmentSection",
          icon: "mdi-forklift",
          text: "Fulfillment",
          children: [
            {
              name: "ordersSummary",
              icon: "mdi-view-list-outline",
              text: "Order summary",
              permissionKey:
                "app_ecom_vendors:fulfillment_sale_order_count_track",
            },
            {
              name: "shipmentSummary",
              icon: "mdi-plus-box-outline",
              text: "Shipment Summary",
              permissionKey: "app_ecom_vendors:fulfillment_order_track_count",
            },
            {
              name: "OrdersList",
              icon: "mdi-cart-check",
              text: "Order List",
              permissionKey: "app_ecom_vendors:fulfillment_sale_order_list",
            },
            {
              name: "OrderList",
              icon: "mdi-package-variant-closed",
              text: "Shipping List",
              permissionKey: "app_ecom_vendors:aev__fulfillment_order_list",
            },
            {
              name: "UploadOrder",
              icon: "mdi-cart-arrow-up",
              text: "Upload Order",
              permissionKey: "app_ecom_vendors:fulfillment_order_upload",
            },
            {
              name: "HvLvListing",
              icon: "mdi-format-list-bulleted-square",
              text: "HV-LV Setting ",
              permissionKey: "app_ecom_vendors:id_list_create",
            },
            {
              name: "LocalBoeOutbound",
              icon: "mdi-file-upload-outline",
              text: "BOE Outbound",
              permissionKey: "app_ecom_vendors:boe_outbound_list_local",
            },
            {
              name: "Vendor",
              icon: "mdi-van-utility",
              text: "Vendor",
              permissionKey: "app_ecom_vendors:vendor_list",
            },

            {
              name: "ProductsSrction",
              icon: "mdi-cart-outline",
              text: "Product / ASN",
              children: [
                {
                  name: "UploadProduct",
                  icon: "mdi-upload-outline",
                  text: "Upload",
                  permissionKey: "app_ecom_vendors:fulfillment_sku_import",
                },
                {
                  name: "ProductList",
                  icon: "mdi-format-list-bulleted-square",
                  text: "Uploaded List",
                  permissionKey: "app_ecom_vendors:fulfillment_sku_list",
                },
                {
                  name: "SkuList",
                  icon: "mdi-store-outline",
                  text: "List of Sku",
                  permissionKey: "app_ecom_vendors:fulfillment_skus",
                },
                {
                  name: "OMSScreen",
                  icon: "mdi-format-list-text",
                  text: "List of Categories",
                  permissionKey: "app_ecom_vendors:fulfillment_sku_category",
                },
              ],
            },
            {
              name: "ProductsSection",
              icon: "mdi-cart-outline",
              text: "Inbound Orders",
              children: [
                {
                  name: "AddInboundOrder",
                  icon: "mdi-upload-outline",
                  text: "Add Inbound Order",
                  permissionKey: "app_ecom_vendors:fulfillment_po_upload",
                },
                {
                  name: "ListInboundOrder",
                  icon: "mdi-upload-outline",
                  text: "List of Inbound Order",
                  permissionKey: "app_ecom_vendors:fulfillment_po_list",
                },
              ],
            },
            {
              name: "Channel",
              icon: "mdi-domain",
              text: "Channel Sku Mapping",
              permissionKey:
                "app_ecom_vendors:fulfillment_channel_sku_mapping_list",
            },
            {
              name: "Inventory",
              icon: "mdi-store-check-outline",
              text: "Inventory",
              permissionKey:
                "app_ecom_vendors:fulfillment-inventory-snapshot-list",
            },
            {
              name: "InventoryLedgerList",
              icon: "mdi-store-check-outline",
              text: "Inventory Ledger List",
              permissionKey:
                "app_ecom_vendors:fulfillment-inventory-ledger-list",
            },
            {
              name: "shelfwiseLedgerList",
              icon: "mdi-store-check-outline",
              text: "Inventory Shelfwise",
              permissionKey:
                "app_ecom_vendors:fulfillment-inventory-shelfwise-list",
            },
          ],
        },
        {
          name: "PasSection",
          text: "PAS",
          icon: "mdi-barcode-scan",
          children: [
            {
              name: "pasList",
              icon: "mdi-view-dashboard-edit-outline",
              text: "List",
              permissionKey: "app_pas:pas_gate_token_get",
            },

            {
              name: "PasHome",
              icon: "mdi-view-dashboard-edit-outline",
              text: "Create Token",
              permissionKey: "app_pas:pas_gate_token_create",
            },
            {
              name: "PasGateIn",
              icon: "mdi-view-dashboard-edit-outline",
              text: "Gate In",
              permissionKey: "app_pas:security_gate_in_out",
            },
            {
              name: "PasGateOut",
              icon: "mdi-view-dashboard-edit-outline",
              text: "Gate Out",
              permissionKey: "app_pas:security_gate_in_out",
            },
            {
              name: "driverFeedback",
              icon: "mdi-view-dashboard-edit-outline",
              text: "Driver Feedback",
              permissionKey: "app_pas:pas_driver_feedback_create",
            },
            {
              name: "PasDockIn",
              icon: "mdi-view-dashboard-edit-outline",
              text: "Dock In",
              permissionKey: "app_pas:warehouse_dock_in_out",
            },
            {
              name: "PasDockOut",
              icon: "mdi-view-dashboard-edit-outline",
              text: "Dock Out",
              permissionKey: "app_pas:warehouse_dock_in_out",
            },
            {
              name: "PasSearchToken",
              icon: "mdi-barcode",
              text: "Search Token",
              permissionKey: "app_pas:pas_search_token",
            },
          ],
        },
        {
          name: "Download",
          icon: "mdi-download-box-outline",
          text: "Download",
          permissionKey: "app_report_export:er-sidebar",
        },

        {
          name: "Overtime",
          icon: "mdi-account-clock",
          text: "Resource",
          children: [
            {
              name: "vendorRateCard",
              icon: "mdi-receipt",
              text: "Rate Card",
              children: [
                {
                  name: "Addratecard",
                  icon: "mdi-equal-box",
                  text: "Add Rate Card",
                  permissionKey: "app_osl_overtime_cost:add_rate_card",
                },
                {
                  name: "ListvendorRateCard",
                  icon: "mdi-equal-box",
                  text: "List of Rate Card",
                  permissionKey: "app_osl_overtime_cost:list_rate_card",
                },
              ],
            },
            {
              name: "vendorRateCard",
              icon: "/images/User Access White.svg",
              text: "Timesheet",
              children: [
                {
                  name: "AddTimesheet",
                  icon: "mdi-calendar-clock",
                  text: "Add Timesheet",
                  permissionKey:
                    "app_osl_overtime_cost:request_application_upload",
                },
                {
                  name: "TimesheetList",
                  icon: "mdi-clipboard-text-clock-outline",
                  text: "List of Timesheet(s)",
                  permissionKey:
                    "app_osl_overtime_cost:request_application_list",
                },

                {
                  name: "timesheetSummary",
                  icon: "mdi-chart-timeline",
                  text: "Timesheet Summary",
                  permissionKey:
                    "app_osl_overtime_cost:osl_summary_month_wise_list",
                },
                {
                  name: "attendanceList",
                  icon: "mdi-timetable",
                  text: "List of Attendance",
                  permissionKey:
                    "app_osl_overtime_cost:vendor_employee_attendance_list",
                },
              ],
            },
          ],
        },
        {
          name: "AccountSettings",
          icon: "/images/Account Settings.svg",
          text: "Settings",
          children: [
            {
              name: "UsersList",
              icon: "/images/User Access White.svg",
              text: "Users",
              permissionKey: "app_sub_accounts:user_sub_user_api_list_create",
            },
            {
              name: "CountrySettings",
              icon: "/images/Subscriptions White.svg",
              text: "Country",
              permissionKey: "app_base:country_settings_list",
            },
            {
              name: "TrackLblSub",
              icon: "/images/Subscriptions White.svg",
              text: "Subscription(s)",
              permissionKey: "app_sub_accounts:user_sub_user_api_list_create",
            },
            {
              name: "ChangePassword",
              icon: "/images/Change Password White.svg",
              text: "Password Change",
              permissionKey: "change-password",
            },

            {
              name: "ListConfiguration",
              icon: "/images/Configure Manifest White.svg",
              text: "Configuration",
              permissionKey: "app_encrypt_decrypt:configuration_list",
            },
            {
              name: "MnfConfiguration",
              icon: "/images/Configure Manifest White.svg",
              text: "Configure Manifest",
              permissionKey: "app_consolidations:package_column_field",
            },
            {
              name: "DrfLogs",
              icon: "mdi-database",
              text: "Drf Logs",
              permissionKey: "rsa_api_logger:log-data",
            },
          ],
        },
        {
          name: "ServiceCenter",
          icon: "mdi-frequently-asked-questions",
          text: "Service Center",
          children: [
            {
              name: "ServieCenterList",
              icon: "mdi-frequently-asked-questions",

              text: "Document List",
              permissionKey: "app_logistics:logistics_doc_list",
            },
          ],
        },
      ],
    };
  },
  methods: {
    checkNavOverflow() {
      const navDrawer = document.querySelector(".v-navigation-drawer__content");
      if (navDrawer.scrollHeight > navDrawer.clientHeight) {
        this.scrollable = true;
      } else {
        this.scrollable = false;
      }
    },

    onClickOutside() {
      if (!this.$vuetify.breakpoint.smAndDown) {
        this.mini = true;
      }
    },
  },
};
</script>
<style lang="scss">
.customwidth {
  width: 72px !important;
}
.side-bar-menu {
  .v-list-group__items {
    display: none;
  }

  .dropdown-level-1 .v-list-group__items {
    padding-left: 20px;
    display: block;
  }

  .v-list-item__icon {
    margin-right: 12px !important;
  }

  .dropdown-level-2 {
    .v-list-group__header {
      padding-left: 8px !important;
    }

    .v-list-group__items {
      padding-left: 20px;
      display: block;

      .v-list-item {
        padding-left: 8px !important;
      }
    }
  }

  .v-list-group--active {
    background: rgb(88 98 140);
  }
}
</style>
